import React, { useState, useEffect } from 'react';
import { IconButton } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const images = [
  'https://www.bookswagon.com/bannerimages/79_inr.jpg?v=5.3',
  'https://www.bookswagon.com/bannerimages/83_inr.jpg?v=5.3',
  'https://www.bookswagon.com/bannerimages/80_inr.jpg?v=5.3',
  'https://www.bookswagon.com/bannerimages/84_inr.jpg?v=5.3',
];

const Carousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const goToNextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const goToPreviousSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  const containerStyle = {
    position: 'relative',
    width: '100%', // Changed from '80%' to '100%'
    margin: 'auto',
    overflow: 'hidden'
  };

  const imageStyle = {
    width: '100%',
    display: 'block',
    transition: 'opacity 0.5s ease-in-out'
  };

  const buttonStyle = {
    position: 'absolute',
    top: '50%',
    zIndex: 10,
    color: 'white'
  };

  const dotContainerStyle = {
    position: 'absolute',
    bottom: '10px',
    width: '100%',
    textAlign: 'center'
  };

  const dotStyle = (isActive) => ({
    cursor: 'pointer',
    height: '10px',
    width: '10px',
    margin: '0 2px',
    backgroundColor: isActive ? 'white' : 'gray',
    borderRadius: '50%',
    display: 'inline-block'
  });

  return (
    <div style={containerStyle}>
      <div>
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Slide ${index + 1}`}
            style={{
              ...imageStyle,
              display: index === currentIndex ? 'block' : 'none'
            }}
          />
        ))}
      </div>
      <IconButton onClick={goToPreviousSlide} style={{ ...buttonStyle, left: '10px' }}>
        <ArrowBackIosIcon />
      </IconButton>
      <IconButton onClick={goToNextSlide} style={{ ...buttonStyle, right: '10px' }}>
        <ArrowForwardIosIcon />
      </IconButton>
      <div style={dotContainerStyle}>
        {images.map((_, index) => (
          <span
            key={index}
            onClick={() => setCurrentIndex(index)}
            style={dotStyle(index === currentIndex)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default Carousel;
